The date & time the `PositionProfile` was closed.

`PositionProfile`s are closed automatically when they reach their `PostingInstruction.end` date.
They can also be closed early using the `closePostedPositionProfile` mutation.

This field has weak ordering guarantees, so it should not be used as a pagination argument.
